import React from 'react';
import { Box, Typography } from '@material-ui/core';

interface DeprecatedPageProps {
  pageName: string;
  farmhandPath: string;
}

const DeprecatedPage: React.FC<DeprecatedPageProps> = ({ pageName, farmhandPath }) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="80vh"
    flexDirection="column"
    style={{ gap: '16px' }}
  >
    <Typography variant="h4">{pageName}</Typography>
    <Typography variant="body1" style={{ color: '#666' }}>
      This page has been deprecated. This feature is now available in FarmHand.
    </Typography>
    <a
      href={`https://farmhand.prod.halter.io${farmhandPath}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: '#1976d2', fontSize: '1.1rem' }}
    >
      Open in FarmHand &rarr;
    </a>
  </Box>
);

export default DeprecatedPage;
